import { API } from '../Api';

/**
 * Donate campaign ("Tạo mục tiêu donate" — REQ mục 4).
 * Gọi BE thật: cab-payment-service qua gateway /v1/payment-service/donate-campaigns.
 * Gateway tự inject `auid` (định danh người gọi) từ JWT → FE không cần truyền auid.
 */

const BASE = '/v1/payment-service/donate-campaigns';

export interface ApiDonor {
  userId: string;
  userName: string;
  amount: number;
  message?: string;
  at: string;
}

export interface ApiCampaignUpdate {
  id: string;
  content: string;
  imageUrl?: string | null;
  authorName: string;
  at: string;
}

export interface ApiDonateCampaign {
  id: string;
  ownerId: string;
  ownerName: string;
  title: string;
  content: string;
  imageUrl?: string | null;
  goalType: 'amount_time' | 'amount';
  targetAmount: number;
  startAt: string;
  endAt?: string | null;
  raised: number;
  closed: boolean;
  createdAt: string;
  withdrawStatus: 'none' | 'requested' | 'disbursed';
  feeAmount?: number | null;
  netAmount?: number | null;
  txId?: string | null;
  disbursedAt?: string | null;
  donors: ApiDonor[];
  updates: ApiCampaignUpdate[];
}

export interface CreateDonateCampaignPayload {
  ownerName: string;
  title: string;
  content: string;
  imageUrl?: string; // base64 data-URL (tuỳ chọn)
  goalType: 'amount_time' | 'amount';
  targetAmount: number;
  startAt: string;
  endAt?: string | null;
}

export const createDonateCampaign = async (
  payload: CreateDonateCampaignPayload
): Promise<ApiDonateCampaign> => {
  const res = await API.post(BASE, payload);
  return res.data;
};

export const fetchDonateCampaigns = async (
  ownerId: string
): Promise<ApiDonateCampaign[]> => {
  const res = await API.get(`${BASE}?ownerId=${ownerId}`);
  return res.data;
};

export const fetchDonateCampaign = async (
  id: string
): Promise<ApiDonateCampaign> => {
  const res = await API.get(`${BASE}/${id}`);
  return res.data;
};

// Đọc chiến dịch CÔNG KHAI (không cần đăng nhập) — cho trang /old: tổng đã góp + lịch sử donor.
export const fetchPublicDonateCampaign = async (
  id: string
): Promise<ApiDonateCampaign & { donors?: ApiDonor[] }> => {
  const res = await API.get(`/v1/payment-service/public/donate-campaigns/${id}`);
  return res.data;
};

export const updateDonateCampaign = async (
  id: string,
  payload: { title?: string; content?: string; imageUrl?: string }
): Promise<ApiDonateCampaign> => {
  const res = await API.put(`${BASE}/${id}`, payload);
  return res.data;
};

export const donateToCampaign = async (
  id: string,
  payload: { amount: number; message?: string; donorName?: string }
): Promise<ApiDonateCampaign> => {
  const res = await API.post(`${BASE}/${id}/donate`, payload);
  return res.data;
};

export const requestCampaignWithdraw = async (
  id: string
): Promise<ApiDonateCampaign> => {
  const res = await API.post(`${BASE}/${id}/withdraw`, {});
  return res.data;
};

export const addCampaignUpdate = async (
  id: string,
  payload: { content: string; imageUrl?: string; authorName?: string }
): Promise<ApiDonateCampaign> => {
  const res = await API.post(`${BASE}/${id}/updates`, payload);
  return res.data;
};
